import React from 'react'
import PropTypes from 'prop-types'

import InputMask from 'react-input-mask'

import { v4 as uuidv4 } from 'uuid'

import cn from 'classnames'

import './index.scss'

const TextField = props  => {
  const [ state, setState ] = React.useState({
    id: props.id || uuidv4(),
  })

  React.useEffect( () => {
    const killArrowInput = e => {
      if(e.target.classList.contains('textfield')){
        if(e.which === 38 || e.which === 40) {
          e.preventDefault()
        }
      }
    }
    window.addEventListener('keydown', killArrowInput)
    return () => {
      window.removeEventListener('keydown', killArrowInput)
    }
  }, [])

  return <div className={cn( 'textfield-container', props.className, { error: props.hasError } ) }>
    <InputMask
      className={`textfield ${props.className || ''} ${props.value ? 'has-value' : ''}`}
      type={props.type}
      id={state.id}
      value={props.value || ''}
      onChange={ e => props.onChange(e.target.value) }
      onFocus={ () => props.onFocus() }
      autoFocus={props.autoFocus}
      maxLength={props.maxLength}
      mask={props.mask}
      />
    <label className={cn({isValid: props.value.trim().length > 0})} htmlFor={state.id}>{props.label}</label>
  </div>
}

TextField.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string,
}

TextField.defaultProps = {
  autoFocus: false,
  className: '',
  hasName: false,
  onFocus: () => {},
  type: 'text',
}

export default TextField
